export type WidgetScriptConfig = {
  publicKey: string;
  apiUrl: string;

  theme?: "system" | "light" | "dark";
  position?: "left" | "right";
  primaryColor?: string;
  radius?: number;
};

function findScript(): HTMLScriptElement | null {
  const current = document.currentScript;
  if (current && current instanceof HTMLScriptElement) return current;

  const scripts = Array.from(
    document.querySelectorAll<HTMLScriptElement>("script[data-widget-key]"),
  );
  return scripts[scripts.length - 1] ?? null;
}

export function getWidgetScriptConfig(): WidgetScriptConfig | null {
  const script = findScript();
  const publicKey = script?.dataset.widgetKey;
  if (!publicKey) return null;

  const apiUrl =
    script?.dataset.apiUrl ||
    (() => {
      // If widget.js is served from the API server, infer /api.
      const src = script?.src;
      if (!src) return "http://localhost:4000/api";
      try {
        const u = new URL(src);
        return `${u.origin}/api`;
      } catch {
        return "http://localhost:4000/api";
      }
    })();

  const themeRaw = script?.dataset.theme;
  const theme =
    themeRaw === "light" || themeRaw === "dark" || themeRaw === "system"
      ? themeRaw
      : undefined;

  const positionRaw = script?.dataset.position;
  const position =
    positionRaw === "left" || positionRaw === "right" ? positionRaw : undefined;

  const primaryColor = script?.dataset.primaryColor;

  const radiusRaw = script?.dataset.radius;
  const radius = radiusRaw ? Number(radiusRaw) : undefined;

  return {
    publicKey,
    apiUrl,
    theme,
    position,
    primaryColor,
    radius:
      typeof radius === "number" && Number.isFinite(radius)
        ? radius
        : undefined,
  };
}
